<template>
  <sdPageHeader :title="$t('pages.tickets.create.title')" />
  <Main>
    <a-row :gutter="25">
      <a-col :md="24" :xs="24">
        <sdCards :title="$t('pages.tickets.create.ticket-info')">
          <a-form :model="form" layout="vertical" @submit="handleSubmit">
            <a-form-item :label="$t('pages.tickets.create.ticket-title')">
              <a-input :placeholder="$t('pages.apps.general.input-title-short-desc')" v-model:value="form.title" />
            </a-form-item>
            <div style="margin: 24px 0" />
            <a-form-item :label="$t('pages.tickets.create.ticket-content')">
              <ckeditor :editor="editor" v-model="form.content" :config="editorConfig"></ckeditor>
            </a-form-item>

            <a-form-item :label="$t('pages.tickets.create.ticket-priority')">
              <a-radio-group v-model:value="form.priority">
                <a-radio value="normal">{{ $t('pages.tickets.create.normal') }}</a-radio>
                <a-radio value="danger">{{ $t('pages.tickets.create.important') }}</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item>
              <a-button :loading="iconLoading" type="primary" html-type="submit">
                {{ $t('common.save') }}
              </a-button>
            </a-form-item>
          </a-form>
        </sdCards>
      </a-col>
    </a-row>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: {
    Main,
  },
  data() {
    return {
      editor: ClassicEditor,
      iconLoading: false,
      editorConfig: {},
      form: {
        title: '',
        content: '',
        priority: 'normal',
      },
    };
  },
  methods: {
    createTicket() {
      this.iconLoading = true;
      this.$appAxios
        .post(this.$endpoints.ticket_create, this.form)
        .then((resp) => {
          if (resp.data.status === true) {
            this.$message.success(this.$t('common.success-message'));
            this.iconLoading = false;
            this.$router.go(-1);
          } else {
            this.iconLoading = false;
            this.$message.error(resp.data.message, 4);
          }
        })
        .catch((e) => {
          this.iconLoading = false;
          this.$message.error(this.$t('common.error-message'));
        });
    },
    handleSubmit() {
      this.createTicket();
    },
  },
};
</script>
